import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, Table } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    titleSize: { 
        marginTop: 20, 
        fontSize: '1.4rem' 
    },
    tableRowColor: { 
        background: '#212121'
    },
    titlesFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        overflowX: 'auto',
        marginBottom: 10
    },
    title: {
        whiteSpace: "nowrap"
    },
    tableRowColor: { 
        background: '#212121' 
    },
    tableCellFormat: { 
        fontSize: '1.2rem', 
        textAlign: 'center' 
    },
    tableCellContentFormat: { 
        textAlign: 'center' 
    }
}));

function DetainedPackages(props) {
    const classes = useStyles();
    const {t} = useTranslation('updateToolbox');

    const columns = [
        t("bag_no"),
        t("order_id"),
        t("tno"),
        t("blocking_batch"),
        t("batch")
    ];

    const [rows, setRows] = useState([]);

    useEffect(() => {
        if(props.detainedTable) {
            setRows(props.detainedTable);
        }
    }, [props.detainedTable])

    return (
        <>
            <Table>
                <TableHead 
                    className={classes.tableRowColor}
                >
                    <TableRow 
                        className={classes.tableRowColor}
                    >
                    {
                        columns.map((title) => (
                            <TableCell align="center">{title}</TableCell>
                        ))
                    }
                    </TableRow>
                </TableHead>
                <TableBody>
                {
                    rows.length > 0 && rows.map((row) => (
                        <TableRow>
                            <TableCell align='center'>{row.bag_no}</TableCell>
                            <TableCell align='center'>{row.order_id}</TableCell>
                            <TableCell align='center'>{row.tno}</TableCell>
                            <TableCell align='center'>{row.blocking_batch}</TableCell>
                            <TableCell align='center'>{row.reference}</TableCell>
                        </TableRow>
                    ))
                }
                </TableBody>
            </Table>
        </>
    );
}

export default DetainedPackages;